import axios from "axios";

// export const baseUrl = "https://vendzeedashboard.in:8443";
// export const baseUrl = "http://dev.gnowee.in:8000";
// export const baseUrl = "http://127.0.0.1:8000";
// export const baseUrl = "https://vm.localheros.in:7443/";
export const baseUrl = "https://dashboard.vendcraftz.in:8443";
// export const baseUrl = "http://dashboard.vendcraftz.in:8000";

const server_api = axios.create({
  baseURL: baseUrl,
});

const onRequest = (config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) {
    return config;
  }
  config.headers["Authorization"] = `Bearer ${user?.access}`;
  return config;
};
const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = async (error) => {
  const config = error.config;
  if (error.response) {
    // Access Token was expired
    if (
      error.response.status === 401 &&
      error.response.data.code === "token_not_valid" &&
      !config?.sent
    ) {
      //   console.clear();
      const user = JSON.parse(localStorage.getItem("user"));
      config.sent = true;
      try {
        const rs = await axios.post(`${baseUrl}/api/token/refresh`, {
          refresh: user.refresh,
        });

        const { access, refresh } = rs.data;
        user.access = access;
        user.refresh = refresh;
        localStorage.setItem("user", JSON.stringify(user));
        config.headers = {
          ...config.headers,
          authorization: `Bearer ${access}`,
        };
        return server_api(config);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
  }
  return Promise.reject(error);
};

server_api.interceptors.request.use(onRequest, onRequestError);
server_api.interceptors.response.use(onResponse, onResponseError);

export default server_api;
